import React from 'react';
import { Box, Grid, Card, CardContent, Typography, Button, List, ListItem, ListItemText } from '@mui/material';
import { 
  Assignment, 
  Pending, 
  CheckCircle, 
  Cancel,
  GetApp 
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const StatCard = ({ title, value, icon, color, onClick }) => (
  <Card sx={{ height: '100%', cursor: onClick ? 'pointer' : 'default' }} onClick={onClick}>
    <CardContent>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography color="textSecondary" gutterBottom variant="overline">
            {title}
          </Typography>
          <Typography variant="h4" component="div" color={color}>
            {value}
          </Typography>
        </Box>
        <Box sx={{ color: color, fontSize: 40 }}>
          {icon}
        </Box>
      </Box>
    </CardContent>
  </Card>
);

const StaffDashboard = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Staff Dashboard
      </Typography>
      
      <Typography variant="body1" color="text.secondary" mb={3}>
        Manage and process ex-gratia applications
      </Typography>

      {/* Staff Statistics */}
      <Grid container spacing={3} mb={4}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Assigned to Me"
            value="12"
            icon={<Assignment />}
            color="primary.main"
            onClick={() => navigate('/applications?filter=assigned')}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Pending Review"
            value="8"
            icon={<Pending />}
            color="warning.main"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Processed Today"
            value="5"
            icon={<CheckCircle />}
            color="success.main"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Available to Pull"
            value="23"
            icon={<GetApp />}
            color="info.main"
            onClick={() => navigate('/applications?filter=available')}
          />
        </Grid>
      </Grid>

      {/* Staff Actions */}
      <Grid container spacing={3} mb={4}>
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Recent Applications
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText
                    primary="APP-2025-001234"
                    secondary="House Damage - Awaiting Review"
                  />
                  <Button size="small" variant="outlined">
                    View
                  </Button>
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="APP-2025-001235"
                    secondary="Crop Loss - Processing"
                  />
                  <Button size="small" variant="outlined">
                    View
                  </Button>
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="APP-2025-001236"
                    secondary="Livestock Loss - Pending Documents"
                  />
                  <Button size="small" variant="outlined">
                    View
                  </Button>
                </ListItem>
              </List>
              <Button 
                variant="contained" 
                fullWidth
                onClick={() => navigate('/applications')}
                sx={{ mt: 2 }}
              >
                View All Applications
              </Button>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Quick Actions
              </Typography>
              <Box display="flex" flexDirection="column" gap={1}>
                <Button 
                  variant="outlined" 
                  fullWidth
                  onClick={() => navigate('/applications?filter=available')}
                >
                  Pull New Application
                </Button>
                <Button 
                  variant="outlined" 
                  fullWidth
                  onClick={() => navigate('/applications/new')}
                >
                  Create Application
                </Button>
                <Button 
                  variant="outlined" 
                  fullWidth
                  onClick={() => navigate('/reports')}
                >
                  View Reports
                </Button>
              </Box>
            </CardContent>
          </Card>
          
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Today's Target
              </Typography>
              <Typography variant="h4" color="primary.main">
                15
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Applications to process
              </Typography>
              <Box mt={2}>
                <Typography variant="body2">
                  Progress: 5/15 (33%)
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StaffDashboard;
